import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-newFolderDialog',
  templateUrl: './newFolderDialog.component.html',
  styleUrls: ['./newFolderDialog.component.css']
})
export class NewFolderDialogComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<NewFolderDialogComponent>,
    private translateService: TranslateService,
  ) { }

  folderName: string;
  curPath: string;

  ngOnInit() {
    if (this.data.path) {
      this.curPath = this.data.path;
    }
  }
}
